<template>

<app-view-list-field align="center" :demoted-icon="field.type" :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

    <span v-if="item.players.length">{{ item.players.length }}</span>
    <span v-if="!item.players.length">-</span>

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted']

}

</script>

<style scoped>

</style>